// extracted by mini-css-extract-plugin
export default {"search-button":"H810","searchButton":"H810","icon":"kxpg","keyboard-key":"wom3","keyboardKey":"wom3"};